import { render, staticRenderFns } from "./pdf3.vue?vue&type=template&id=b058b86a&scoped=true&"
import script from "./pdf3.vue?vue&type=script&lang=js&"
export * from "./pdf3.vue?vue&type=script&lang=js&"
import style0 from "./pdf3.vue?vue&type=style&index=0&id=b058b86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b058b86a",
  null
  
)

export default component.exports